import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import app from "./firebaseConfig.js";

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };